import React from 'react';
import { Box, Card, Carousel, Link } from '@drone-js/core';
import { ReviewMediaDisplay } from 'component/page/detail/Review/Review.selectors';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import {
    ActivitiesReviewCardImageClickEventActivitiesFieldsV1,
    ActivitiesReviewCardImageSeenEventActivitiesFieldsV1,
} from '@agoda/analytics-messages-definition-activities/events.split';
import {
    ActivitiesReviewCardImageClickEventActivitiesManifestV1,
    ActivitiesReviewCardImageSeenEventActivitiesManifestV1,
} from '@agoda/analytics-messages-definition-activities/manifest/events';
import { useSelector } from 'react-redux';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { InView } from 'react-intersection-observer';
import { StringFormatter } from '@agoda/react-handyman';
import { ActivityImage } from 'component/common/ActivityImage/ActivityImage';

interface OwnProps {
    reviewMedia: ReviewMediaDisplay[];
    reviewId: number;
    isModalVisible: (isVisible: boolean, index: number) => void;
}

type Props = OwnProps;

const ReviewCardGallery: React.FC<Props> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);
    const reviewMedia = props.reviewMedia;
    const mediaLength = reviewMedia?.length ?? 0;

    const onSeen = (index: number) => (inView: boolean) => {
        if (!inView) return;
        trackElementEvent<ActivitiesReviewCardImageSeenEventActivitiesFieldsV1>(
            ActivitiesReviewCardImageSeenEventActivitiesManifestV1.ids,
            {
                is_modal: false,
            },
            { action_element_index: index + 1, action_element_value: props.reviewId.toString() },
        );
    };

    if (!reviewMedia || !mediaLength) {
        return null;
    }

    const onImageClick = (index: number) => {
        trackElementEvent<ActivitiesReviewCardImageClickEventActivitiesFieldsV1>(
            ActivitiesReviewCardImageClickEventActivitiesManifestV1.ids,
            { is_modal: false },
            { action_element_index: index + 1, action_element_value: props.reviewId.toString() },
        );
        props.isModalVisible(true, index);
    };

    return (
        <Box mt="12" data-testid="activities-card-gallery">
            <Carousel fade="visible" cardWidth={96} accessibilityLabel={cms[276248]} accessibilityPreviousNavLabel={cms[130765]} accessibilityNextNavLabel={cms[130706]}>
                {reviewMedia.map((media, index) => (
                    // Drone's Link without href will be rendered as <button>
                    // eslint-disable-next-line jsx-a11y/anchor-is-valid, @agoda/agoda-a11y/no-inaccessible-drone-link -- jsx-a11y/anchor-is-valid[4ab3d3f5-85ab-4063-86cd-110c3aba2237], @agoda/agoda-a11y/no-inaccessible-drone-link[0255bde1-321c-4573-b7c3-b686c6eb3a86]
                    <Link
                        key={index}
                        data-element-name="activities-review-card-image"
                        data-testid="activities-review-card-image"
                        data-element-index={index + 1}
                        aria-label={StringFormatter.format(cms[321482], index + 1, props.reviewMedia.length)}
                        onClick={() => onImageClick(index)}
                    >
                        <InView onChange={onSeen(index)} triggerOnce={true} threshold={1}>
                            <Card mt="8" type="interactive" width="96px" height="96px">
                                <ActivityImage
                                    aspectRatio="1"
                                    objectFit="cover"
                                    src={media.source}
                                    alt={StringFormatter.format(cms[321482], index + 1, props.reviewMedia.length)}
                                    borderRadius="16"
                                />
                            </Card>
                        </InView>
                    </Link>
                ))}
            </Carousel>
        </Box>
    );
};

ReviewCardGallery.displayName = 'ReviewCardGallery';
export default ReviewCardGallery;
